let other = {
  noReason: 'No Reason',
  /* 佣金历史 */
  total: 'Total',
  commissionTotal: 'Commission Total',
  IBAccount: 'IB Account',
  tradingAccount: 'Trading Account',
  transactionNumber: 'Transaction Number',
  confirmDeductions: 'Confirm Deductions',
  confirmTransfer: 'Confirm Transfer？',
  selectGroup: 'Please Select Group',
  selectType: 'Please Select Type',
  selectDatetime: 'Select Datetime',
  addRebate: 'Add Rebate Info',
  /* placeholder */
  enterTicket: 'Enter Ticket',
  enterAccount: 'Enter Account',
  enterLogin: 'Enter Login',
  enterSymbol: 'Enter Symbol',
  selectClientGroup: 'select Client Group',
  selectCMD: 'Select CMD',
  enterVolume: 'Enter Volume',
  selectOpentime: 'Select Opentime',
  selectClosetime: 'Select Closetime',
  selectRightDate: 'Select Right Date',
  enterProfit: 'Enter Profit',
  /* 导入导出表格 */
  selectExportType: 'Select Export Table Type',
  importExcel: 'Upload',
  exportExcel: 'Export',
  selectDate: 'Select Date',
  /* 银行卡审核 */
  bankcardCheck: 'Bank Card Audit',
  sureEditCharge: 'Are you sure modify charge?',
  updateTime: 'Update Time',
  firstWithdraw: 'First Withdraw',
  isWithdrawed: 'the month is Withdrawed',
  time: 'times',
  checked: 'Have Checked',
  noChecked: 'No Checked',
  refused: 'Have refused',
  plus: 'plus',
  minus: 'minus',
  confirmBankcardInfo: 'Confirm bank card information?',
  confirmRefuse: 'Confirm refuse?',
  confirmSuccess: 'confirm successful',
  transferSuccess: 'Transfer application successful',
  haveEditPwd: 'User Has Changed Password',
  editUserGroupSuccess: 'Edit User Group successful',
  editUserGroupFailed: 'Edit User Group Failed',
  /* 账单 */
  billAccount: 'ACCOUNT',
  billLogin: 'LOGIN',
  billOrder: 'ORDER',
  billType: 'TYPE',
  billLoss: 'PROFIT',
  billTime: 'CREATE TIME',
  warm_prompt: "Kindly remind:",
  gold: "① The first withdrawal of every canlender month is free, then any withdrawal after that will be charged $ 10 as process fee.",
  estimated: "② The expected process fee for this withdrawal: $ 0 ( for reference only).",
  bank_country: 'Bank Country',
  enterBankCountry: 'Enter Bank Country',
  formatError: 'Format error',
  other_login: 'Login',
  other_en: 'EN (English)',
  other_cn: 'CN (Chinese)',
  other_ae: 'AR (Arab)',
  activeAccounts: 'Active Accounts',
  inactiveAccounts: 'Inactive Accounts',
  other_footer: ' © 2022 Copyright all rights reserved',
}

export default other;



// WEBPACK FOOTER //
// ./src/i18n/english/other.js